export const visit = (vm, at) => {
at({ "de": { "upgradePointTooltip": { "upgradePageLink_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, createElement( options, "Link", props, "Upgraden SIe" ), ", um diese Aktion durchzuf\xFChren." ); } } } });
};